import { toast } from "react-toastify";
import "./notification.scss";

export const CreateNotification = (
  message = "Missing data in required fields",
  type = "success",
  position = "top-right",
  autoClose = 5000,
  hideProgressBar = false,
  closeOnClick = true,
  pauseOnHover = true
) => {
  let toastId;

  switch (type) {
    case "success":
      toastId = toast.success("Step done! Next move unlocked.", {
        position,
        autoClose,
        hideProgressBar,
        closeOnClick,
        pauseOnHover,
        bodyClassName: "toastifyStyling",
      });
      break;
    case "warning":
      toastId = toast.warn(message, {
        position,
        autoClose,
        hideProgressBar,
        closeOnClick,
        pauseOnHover,
        bodyClassName: "toastifyStyling",
      });
      break;
    case "error":
      toastId = toast.error(message ? message : "Missing data in required fields", {
        position,
        autoClose,
        hideProgressBar,
        closeOnClick,
        pauseOnHover,
        bodyClassName: "toastifyStyling",
      });
      break;
    default:
      return;
  }

  return toastId;
};

// Close a specific toast by ID, or all toasts if no ID is passed
export const CloseNotification = (id) => {
  toast.dismiss(id);
};